import { generatePath } from 'react-router'

import { DELIVERY_RECORD_DETAILS } from 'portal/routes'
import { PageContainer } from 'portal/pages/PageContainer'
import { RecordEdit } from 'portal/components/RecordsModules'
import { useModuleIds } from 'portal/lib/hooks'

export const DeliveryEdit = () => {
  const doneUri = useDoneRedirect()

  return (
    <PageContainer>
      <RecordEdit doneUri={doneUri} />
    </PageContainer>
  )
}

function useDoneRedirect() {
  const { accountId, projectId, recordId, moduleName } = useModuleIds()

  return generatePath(DELIVERY_RECORD_DETAILS, {
    accountId,
    projectId,
    recordId,
    moduleName
  })
}
